import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import SelectMenu from '../SelectMenu/SelectMenu';

export const SELECT_IDENTIFIER = 'source_type';

class SelectMenuSourceType extends Component {
  render() {
    const { infoButton, name, meta, label, labelSize } = this.props;
    let source = 'source-types';

    return (
      <FormGroup
        controlId={name}
        className={meta && meta.touched && meta.error ? ' has-error' : ''}
      >
        {label && (
          <Col componentClass={ControlLabel} sm={labelSize}>
            {label} {infoButton}
          </Col>
        )}
        <Col sm={12 - labelSize}>
          <SelectMenu source={source} isObject {...this.props} />

          {meta && meta.touched && meta.error && (
            <span className="input-error">{meta.error}</span>
          )}
        </Col>
      </FormGroup>
    );
  }
}

export default connect()(SelectMenuSourceType);
